import { pushEventData, pushCleanEcommerceObject } from "./utils";
import { GTM_SHIPPING } from "../utilities/constants";
 
const pushShipmentInfoImpression = () => {
    let checkoutDatalayerObj = $("input[name='checkoutDataLayer']").val();
    
    if (checkoutDatalayerObj) {
        let shippingTypes = [];

        $(".step-type--address").each(function () {
            const type = $(this).data("address-store");
            const shipping = GTM_SHIPPING[type] ?? type; // Convert to shipping name, if it doesn't exist, send ID
            shippingTypes.push(shipping);
        });

        checkoutDatalayerObj = JSON.parse(checkoutDatalayerObj);
        checkoutDatalayerObj.event = "add_shipping_info";
        checkoutDatalayerObj.ecommerce.shipping_tier = shippingTypes.join(" | ");
        pushCleanEcommerceObject();
        pushEventData(checkoutDatalayerObj);
    }
};

export {
    pushShipmentInfoImpression
};
